import { Link } from "react-router-dom";
import { categories } from "@/mocks/categories";
import { countByCategory } from "@/utils/site";
import SectionHeading from "@/components/feature/SectionHeading";

export default function CategoryQuick() {
  return (
    <section className="mx-auto max-w-[1280px] px-4 py-12 md:px-6 md:py-16">
      <SectionHeading
        icon="ri-apps-2-line"
        title="热门分类快捷入口"
        subtitle="按场景快速进入对应分类，发现更多实用网站"
      />
      <div className="grid grid-cols-2 gap-3 sm:grid-cols-3 md:gap-4 lg:grid-cols-5">
        {categories.map((c) => (
          <Link
            key={c.id}
            to={`/category/${c.id}`}
            className="group flex flex-col items-center gap-3 rounded-lg border border-background-200 bg-background-50 p-5 transition-colors hover:border-primary-300 hover:bg-primary-50/50"
          >
            <span className="flex h-12 w-12 items-center justify-center rounded-lg bg-primary-100 text-primary-600 transition-colors group-hover:bg-primary-500 group-hover:text-background-50">
              <i className={`${c.icon} text-xl`}></i>
            </span>
            <div className="text-center">
              <p className="text-sm font-semibold text-foreground-950">{c.name}</p>
              <p className="mt-0.5 text-xs text-foreground-500">{countByCategory(c.id)} 个网站</p>
            </div>
          </Link>
        ))}
      </div>
    </section>
  );
}